import {ascend, sort} from 'ramda';

import {UnifiedAlbumImage} from '../types/UnifiedAlbumImage';

export const sortImages = sort<UnifiedAlbumImage>(ascend((image) => image.weight));
